import { render, staticRenderFns } from "./ProjectKPIs.vue?vue&type=template&id=319340c3&scoped=true&"
import script from "./ProjectKPIs.vue?vue&type=script&lang=js&"
export * from "./ProjectKPIs.vue?vue&type=script&lang=js&"
import style0 from "./ProjectKPIs.vue?vue&type=style&index=0&id=319340c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319340c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('319340c3')) {
      api.createRecord('319340c3', component.options)
    } else {
      api.reload('319340c3', component.options)
    }
    module.hot.accept("./ProjectKPIs.vue?vue&type=template&id=319340c3&scoped=true&", function () {
      api.rerender('319340c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/ProjectKPIs.vue"
export default component.exports